import { FaAward, FaUsers, FaBuilding, FaHandshake } from 'react-icons/fa';

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-3 py-12">
      
      {/* Hero Section */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-blue-900 mb-4">
          P&M DREAM MANORS PRIVATE LIMITED
        </h1>
        <p className="text-xl text-gray-600">
          Building Dreams, Creating Homes Since 2020
        </p>
      </div>

      {/* Company Story */}
      <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg p-8 mb-8">
        <h2 className="text-3xl font-semibold text-blue-900 mb-4">Our Story</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          P&M Dream Manors Private Limited was founded with a vision to revolutionize 
          the real estate industry in India. We believe that finding the perfect home 
          should be a joyful experience, not a stressful one.
        </p>
        <p className="text-gray-700 leading-relaxed">
          With years of expertise and a deep understanding of the Indian real estate 
          market, we've helped thousands of families find their dream properties across 
          major cities. Our commitment to excellence and customer satisfaction sets us 
          apart in the industry.
        </p>
      </div>

      {/* Mission & Vision */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-blue-600">
          <h3 className="text-2xl font-semibold text-blue-900 mb-3">Our Mission</h3>
          <p className="text-gray-700 leading-relaxed">
            To provide transparent, trustworthy, and technology-driven real estate 
            solutions that empower our clients to make informed property decisions. 
            We strive to exceed expectations in every transaction.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-amber-500">
          <h3 className="text-2xl font-semibold text-blue-900 mb-3">Our Vision</h3>
          <p className="text-gray-700 leading-relaxed">
            To become India's most trusted real estate platform, where every property 
            transaction is seamless, secure, and satisfying. We envision a future where 
            finding your dream home is as easy as a click.
          </p>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="mb-12">
        <h2 className="text-3xl font-semibold text-blue-900 mb-6 text-center">
          Why Choose P&M Dream Manors?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 text-center">
            <FaAward className="text-5xl text-blue-600 mx-auto mb-4" />
            <h4 className="text-lg font-semibold mb-2">Verified Listings</h4>
            <p className="text-gray-600 text-sm">
              100% verified properties with authentic documentation and transparent pricing.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 text-center">
            <FaUsers className="text-5xl text-green-600 mx-auto mb-4" />
            <h4 className="text-lg font-semibold mb-2">Expert Guidance</h4>
            <p className="text-gray-600 text-sm">
              Professional real estate advisors to guide you through every step.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 text-center">
            <FaBuilding className="text-5xl text-purple-600 mx-auto mb-4" />
            <h4 className="text-lg font-semibold mb-2">Premium Properties</h4>
            <p className="text-gray-600 text-sm">
              Exclusive access to premium residential and commercial properties.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 text-center">
            <FaHandshake className="text-5xl text-amber-600 mx-auto mb-4" />
            <h4 className="text-lg font-semibold mb-2">Customer First</h4>
            <p className="text-gray-600 text-sm">
              24/7 support and commitment to your satisfaction at every stage.
            </p>
          </div>
        </div>
      </div>

      {/* Statistics */}
      <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-lg p-8 mb-12">
        <h2 className="text-3xl font-semibold text-white mb-8 text-center">
          Our Achievements
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="text-center">
            <h3 className="text-4xl font-bold text-amber-400">5000+</h3>
            <p className="text-blue-100 mt-2">Properties Listed</p>
          </div>
          <div className="text-center">
            <h3 className="text-4xl font-bold text-amber-400">3500+</h3>
            <p className="text-blue-100 mt-2">Happy Clients</p>
          </div>
          <div className="text-center">
            <h3 className="text-4xl font-bold text-amber-400">50+</h3>
            <p className="text-blue-100 mt-2">Cities Covered</p>
          </div>
          <div className="text-center">
            <h3 className="text-4xl font-bold text-amber-400">98%</h3>
            <p className="text-blue-100 mt-2">Customer Satisfaction</p>
          </div>
        </div>
      </div>

      {/* Company Details */}
      <div className="bg-gray-50 p-8 rounded-lg">
        <h2 className="text-2xl font-semibold text-blue-900 mb-6">Company Information</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
          <div>
            <p className="mb-2">
              <strong>Registered Name:</strong> P&M Dream Manors Private Limited
            </p>
            <p className="mb-2">
              <strong>Corporate Office:</strong> [Your Office Address], Mumbai, Maharashtra
            </p>
            <p className="mb-2">
              <strong>Email:</strong> info@pmdreammanors.com
            </p>
          </div>
          <div>
            <p className="mb-2">
              <strong>Phone:</strong> +91 1234567890
            </p>
            <p className="mb-2">
              <strong>RERA Registration:</strong> [Your RERA Number]
            </p>
            <p className="mb-2">
              <strong>Working Hours:</strong> Monday - Saturday, 9:00 AM - 6:00 PM
            </p>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="text-center mt-12">
        <h3 className="text-2xl font-semibold text-blue-900 mb-4">
          Ready to Find Your Dream Property?
        </h3>
        <p className="text-gray-600 mb-6">
          Let our experts help you find the perfect home that matches your requirements.
        </p>
        <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-200 shadow-lg">
          Contact Us Today
        </button>
      </div>
    </div>
  );
}
